import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  connect() {
    // Recheck scheduled content even if a broadcast was missed.
    this.timer = setInterval(() => Turbo.visit(window.location.href, { action: "replace" }), 60000)
  }

  disconnect() {
    clearInterval(this.timer)
  }
}
